const parseJwt = (token: string) => {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
};

const credentialIsNotExpired = (credential: string) => {
  const parsed = parseJwt(credential);
  const now = Date.now();
  // iat and exp are in seconds
  const issueTime = parsed.iat * 1000;
  const rePromptTime = parsed.exp * 1000;
  return issueTime < now && now < rePromptTime;
};

export { parseJwt, credentialIsNotExpired };
